export interface Article {
  id: number;
  mangaId: number;
  mangaTitle: string;
  chapterNumber: number;
  title: string;
  content: string[];
  prevChapter?: number;
  nextChapter?: number;
  category: string;
  publishedAt: string;
  views: number;
}

export const articles: Article[] = [
  {
    id: 1,
    mangaId: 1,
    mangaTitle: '洞洞杂货铺',
    chapterNumber: 87,
    title: '第87话 命运的选择',
    content: [
      '深夜的小巷中，洞洞杂货铺的灯光依然亮着。',
      '店主林逸坐在柜台后面，手中把玩着一枚泛着微光的硬币。这枚硬币是今天第三位客人留下的——一位想要挽回逝去爱情的年轻人。',
      '"每个人都有自己的命运，但命运从来不是一成不变的。"林逸自言自语道。',
      '他把硬币放进一个古旧的木盒中，木盒发出轻微的嗡鸣声。',
      '就在这时，门上的风铃响了。',
      '一个穿着黑色风衣的神秘男子走了进来。他的眼神锐利，浑身散发着一种说不清道不明的压迫感。',
      '"欢迎光临洞洞杂货铺。"林逸微笑着说，"请问有什么可以帮您的？"',
      '神秘男子摘下帽子，露出一张棱角分明的脸。"我听说这里什么都能买到。"',
      '"那要看你愿意付出什么。"林逸的眼睛在灯光下闪过一丝不易察觉的金色光芒。',
      '神秘男子从怀中掏出一张泛黄的照片，放在柜台上。照片上是一个笑容灿烂的小女孩。',
      '"我想找到她。不管付出什么代价。"',
      '林逸拿起照片，仔细端详。照片上的女孩大约七八岁，扎着两个羊角辫，笑得无忧无虑。',
      '"这是您的女儿？"',
      '"妹妹。"男子的声音有些沙哑，"十年前失踪了。我找遍了所有地方，用尽了所有办法，都没有她的消息。"',
      '林逸沉默了片刻，然后从柜台下拿出一个水晶球。水晶球内部似乎有烟雾在缓缓流动。',
      '"这个可以帮你找到你想找的人。但代价是——你需要放弃你最重要的记忆。"',
      '神秘男子毫不犹豫地点头。"只要能找到她，我什么都愿意。"',
      '林逸将水晶球推到男子面前，同时轻声说道："想清楚，最重要的记忆一旦失去，就再也找不回来了。"',
      '男子的手悬在水晶球上方，微微颤抖。',
    ],
    category: 'qihuan',
    publishedAt: '2026-08-04',
    views: 156000,
  },
  {
    id: 2,
    mangaId: 1,
    mangaTitle: '洞洞杂货铺',
    chapterNumber: 86,
    title: '第86话 镜中的世界',
    content: [
      '上一话中，少女小雅从洞洞杂货铺买走了一面古老的铜镜。',
      '当天晚上，小雅把铜镜挂在卧室的墙上。镜子里的倒影看起来有些奇怪——镜子中的自己似乎在微笑，但她明明没有在笑。',
      '"一定是太累了。"小雅揉了揉眼睛，关灯睡觉。',
      '半夜，她被一阵微弱的敲击声惊醒。',
      '笃、笃、笃。',
      '声音从镜子那边传来。',
      '小雅屏住呼吸，慢慢走到镜子前。月光下，她看到镜中的自己正伸出手指，轻轻敲击着镜面。',
      '但她的手明明垂在身体两侧。',
      '"别害怕。"镜中的"她"开口说话了，声音像是隔着一层水。',
      '"你……你是谁？"小雅的声音在发抖。',
      '"我就是你啊。准确地说，我是被你遗忘的那部分自己。那个勇敢、自信、不畏惧任何人眼光的你。"',
      '小雅愣住了。她想起自己确实曾经是一个充满梦想的女孩，但随着年龄增长，现实的压力和周围人的期待，让她渐渐变成了一个胆小、顺从的人。',
      '"我一直在镜子的另一边看着你。"镜中的她说，"看到你放弃画画，看到你选择了一份你不喜欢的工作，看到你嫁给了一个你不爱的人。你快乐吗？"',
      '小雅的眼眶湿润了。',
      '"我……我不知道。"',
      '"回到杂货铺去。"镜中的她说，"告诉店主，你想换回真正的自己。"',
    ],
    category: 'qihuan',
    publishedAt: '2026-08-01',
    views: 142000,
  },
  {
    id: 3,
    mangaId: 1,
    mangaTitle: '洞洞杂货铺',
    chapterNumber: 85,
    title: '第85话 时间的沙漏',
    content: [
      '一位白发苍苍的老人推开了洞洞杂货铺的门。',
      '他拄着拐杖，步履蹒跚地走到柜台前。',
      '"老板，我想买一些时间。"',
      '林逸抬起头，看着这位满脸皱纹的老人。"时间是最珍贵的东西，也是最难定价的东西。"',
      '老人苦笑道："我这辈子赚了很多钱，买了大房子，买了豪车，却错过了女儿的成长，错过了妻子的生日，错过了太多太多。现在我快死了，才发现那些东西一文不值。"',
      '他从口袋里掏出一把钥匙，"这是我在市中心的一套别墅的钥匙，市值两千万。够不够换一天？不，半天就好。"',
      '林逸摇了摇头。',
      '"钱在杂货铺里没有价值。你需要用别的东西来换。"',
      '"什么都可以！"老人急切地说。',
      '林逸从架子上拿下一个精致的沙漏，里面的金色沙粒缓缓流动。',
      '"这个沙漏可以给你二十四小时的时间。但代价是——你这辈子积累的所有财富和名声。"',
      '老人愣住了。',
      '"全部？"',
      '"全部。你会变成一个身无分文的普通人。但你会拥有完整的一天，可以和家人好好告别。"',
      '老人闭上眼睛，深吸一口气。当他再次睁开眼时，目光变得异常坚定。',
      '"成交。"',
    ],
    category: 'qihuan',
    publishedAt: '2026-07-28',
    views: 138000,
  },
  {
    id: 4,
    mangaId: 3,
    mangaTitle: '修真聊天群',
    chapterNumber: 312,
    title: '第312话 天劫降临',
    content: [
      '天空中乌云密布，雷光在云层中翻滚，仿佛要将整个天地撕裂。',
      '宋书航站在山巅之上，抬头望着那酝酿中的天劫，心中涌起一股豪情。',
      '"终于来了。"他喃喃道。',
      '手机屏幕上，修真聊天群已经炸开了锅。',
      '「灵蝶岛羽柔子」：书航道友！你真的要渡劫了？！',
      '「白尊者」：坐标发我，我给你护法。',
      '「狂刀三浪」：兄弟们，见证历史的时刻到了！史上最速渡劫记录要诞生了！',
      '「铜卦仙师」：@宋书航 我算了一卦，大吉大利，今晚吃鸡！',
      '宋书航笑了笑，快速打字回复："各位道友请放心，区区天劫，何足挂齿。"',
      '然而下一秒，当第一道天雷劈下来的时候，他才意识到自己还是太年轻了。',
      '那道雷电足有水桶粗细，带着毁天灭地的威势，直直地朝他劈来！',
      '"我靠！这不是普通的天劫！这是九天神雷！"',
      '宋书航立刻运转功法，周身涌起金色光芒，硬生生接下了这道雷击。',
    ],
    category: 'rexue',
    publishedAt: '2026-08-04',
    views: 210000,
  },
  {
    id: 5,
    mangaId: 10,
    mangaTitle: '诡秘之主',
    chapterNumber: 198,
    title: '第198话 古神的低语',
    content: [
      '浓雾笼罩着整座城市。',
      '周明瑞站在钟楼的顶端，俯瞰着脚下如同迷宫般的街道。那些雾气中似乎隐藏着无数双眼睛，正注视着他的一举一动。',
      '"你听到了吗？"身边的同伴问道。',
      '周明瑞点了点头。他确实听到了——一种低沉而古老的吟唱，仿佛来自时间的尽头，来自星辰的彼岸。',
      '那是古神的低语。',
      '每一句低语都像一把锤子，敲击着他的理智。普通人哪怕听到一个字，都会立刻陷入疯狂。',
      '但周明瑞已经习惯了。作为一个序列5的非凡者，他的精神力足以抵御大部分的精神污染。',
      '"它要苏醒了。"他说，"我们必须阻止它。"',
      '钟楼的钟声突然响起，但不是报时的声音，而是一种诡异的旋律。',
      '铛——铛——铛——',
      '每一声都让空气变得更加沉重。',
      '雾气中，一个巨大的影子缓缓浮现。',
    ],
    category: 'kongbu',
    publishedAt: '2026-08-04',
    views: 235000,
  },
  {
    id: 6,
    mangaId: 4,
    mangaTitle: '月色真美',
    chapterNumber: 96,
    title: '第96话 永远（最终话）',
    content: [
      '樱花纷飞的季节，校园里弥漫着离别的气息。',
      '周月白站在学校天台，望着远处的夕阳。三年的高中时光即将结束，而他和林夕也将各奔东西——他要去北方的大学，而林夕则选择了南方的艺术学院。',
      '"我就知道你会在这里。"林夕推开天台的门，走到他身边。',
      '"在想什么？"她问。',
      '"在想……我们会不会就这样结束了。"周月白的声音很轻。',
      '林夕没有说话，只是把手伸进了口袋，然后掏出了一个小盒子。',
      '"这是什么？"',
      '"打开看看。"',
      '周月白打开盒子，里面是一条银色的项链，吊坠是一个小小的月亮形状。',
      '"月亮。"林夕说，"不管你在哪里，只要抬头看到月亮，就像看到我一样。"',
      '周月白的眼眶湿润了。',
      '"可是，异地恋……"',
      '"四年而已。"林夕打断了他，笑容灿烂如花，"四年后，无论你去哪里，我都会去找你。"',
      '夕阳的余晖洒在两人身上，樱花在他们身边飞舞。',
      '周月白伸出手，握住了林夕的手。',
      '"好。一言为定。"',
      '两人相视而笑，仿佛整个世界都在这一刻变得无比温柔。',
      '——月色真美。',
      '——永远。',
      '（全文完）',
    ],
    category: 'lianai',
    publishedAt: '2026-06-15',
    views: 98000,
  },
  {
    id: 7,
    mangaId: 6,
    mangaTitle: '暗夜侦探',
    chapterNumber: 58,
    title: '第58话 最后的拼图',
    content: [
      '所有的线索在顾夜明的脑海中汇聚成一幅完整的画面。',
      '"原来如此。"他站在案发现场，嘴角微微上扬。',
      '助手小陈焦急地问："顾队，你想明白了？"',
      '顾夜明点点头，走到白板前，拿起记号笔。',
      '"这个案子有三个关键点。第一，死者身上没有任何外伤，却死于窒息——这说明凶手用的是某种不会留下痕迹的方法。"',
      '"第二，案发现场门窗完好，没有任何破坏痕迹——凶手要么是死者认识的人，要么拥有钥匙。"',
      '"第三，也是最关键的一点——"',
      '顾夜明在白板上画了一个圈。',
      '"冰箱。"',
      '"冰箱？"小陈一脸困惑。',
      '"对。案发当晚，死者的冰箱里有一盒刚买回来的冰淇淋，已经完全融化了。法医推定死亡时间是晚上九点到十点之间，但冰箱里的冰淇淋告诉我们，死亡时间至少提前了两个小时。"',
      '"凶手刻意制造了不在场证明。"顾夜明转身看向在场的所有人，"而能做到这一切的，只有一个人。"',
    ],
    category: 'xuanyi',
    publishedAt: '2026-08-01',
    views: 124000,
  },
];

export function getArticleByChapter(mangaId: number, chapterNumber: number): Article | undefined {
  return articles.find(a => a.mangaId === mangaId && a.chapterNumber === chapterNumber);
}